// extracted by mini-css-extract-plugin
export default {"ShareBody":"shareModal_ShareBody__Yvp4w","ShareBox":"shareModal_ShareBox__h5xuP","ShareTips":"shareModal_ShareTips__VeArG"};